import { useEffect } from 'react'
import { useLocation, useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

// Ensures the `lng` query param persists across navigation and only
// reflects the current i18n language. It doesn't change language by itself.
const PersistLanguageQuery = () => {
  const location = useLocation()
  const [searchParams, setSearchParams] = useSearchParams()
  const { i18n } = useTranslation()

  useEffect(() => {
    const currentLng = searchParams.get('lng')
    const lang = i18n.language

    // If language is English, enforce lng=en in the URL (preserve other params)
    if (lang === 'en' && currentLng !== 'en') {
      const next = new URLSearchParams(searchParams)
      next.set('lng', 'en')
      setSearchParams(next, { replace: true, state: location.state })
      return
    }

    // If language is Georgian (default), ensure lng is removed (preserve others)
    if ((lang === 'ka' || !lang) && currentLng) {
      const next = new URLSearchParams(searchParams)
      next.delete('lng')
      setSearchParams(next, { replace: true, state: location.state })
      return
    }
    // For any other languages in future, do nothing for now.
  }, [
    location.search,
    i18n.language,
    setSearchParams,
    searchParams,
    location.state
  ])

  return null
}

export default PersistLanguageQuery
